/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientAdmissionHistoryViewModel } from './PatientAdmissionHistoryViewModel'; 

export function getAdmissionHistoryOptions(patientId: string, onSuccess?: (result: PatientAdmissionHistoryViewModel[]) => void) {
	return queryOptions({
		queryKey: ['admission-history', patientId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/intake/admissions/queries/getadmissionhistory/' + patientId;
			const resp = await axios.get<PatientAdmissionHistoryViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(patientId)
	});
}